// Paleta de colores del arcoíris para Divertilandia
export const divertilandiaColors = {
  // Colores principales del arcoíris - Versión estándar y elegante
  rainbow: {
    red: '#E74C3C',      // Rojo elegante
    orange: '#F39C12',   // Naranja dorado
    yellow: '#F1C40F',   // Amarillo suave
    green: '#27AE60',    // Verde natural
    blue: '#3498DB',     // Azul profesional
    indigo: '#8E44AD',   // Índigo elegante
    violet: '#9B59B6',   // Violeta suave
  },

  // Colores estándar para elementos fijos
  standard: {
    primary: '#3498DB',     // Azul principal (para títulos, botones principales)
    secondary: '#27AE60',   // Verde secundario (para botones secundarios)
    accent: '#F39C12',      // Naranja de acento (para precios, números importantes)
    success: '#27AE60',     // Verde para éxito/disponible
    warning: '#F1C40F',     // Amarillo para advertencias
    error: '#E74C3C',       // Rojo para errores/no disponible
    info: '#8E44AD',        // Índigo para información
    neutral: '#95A5A6',     // Gris neutro para texto secundario
  },

  // Colores para estados específicos - Usando colores estándar
  status: {
    pending: '#F1C40F',      // Amarillo - Pendiente
    confirmed: '#27AE60',    // Verde - Confirmado
    inProgress: '#3498DB',   // Azul - En Progreso
    completed: '#8E44AD',    // Índigo - Completado
    cancelled: '#E74C3C',    // Rojo - Cancelado
    active: '#27AE60',       // Verde - Activo
    inactive: '#95A5A6',     // Gris - Inactivo
  },

  // Colores para categorías de juguetes - Colores distintivos y vibrantes
  toyCategories: {
    // Categorías específicas de tu base de datos
    'alberca de pelotas': '#F1C40F',        // Amarillo dorado
    'corralitos': '#27AE60',                // Verde esmeralda
    'inflables': '#E67E22',                 // Naranja oscuro
    'juguetes de construcción': '#3498DB',   // Azul cielo
    'montables': '#F39C12',                 // Naranja vibrante
    'tapetes': '#9B59B6',                   // Violeta suave
    'tuneles interactivos': '#E74C3C',      // Rojo coral
    
    // Categorías genéricas por si acaso
    'pelotas': '#F1C40F',                   // Amarillo dorado
    'bloques': '#27AE60',                   // Verde esmeralda
    'muñecas': '#E74C3C',                   // Rojo coral
    'carros': '#3498DB',                    // Azul cielo
    'juegos': '#8E44AD',                    // Índigo púrpura
    'otros': '#95A5A6',                     // Gris neutro
    'electrónicos': '#9B59B6',              // Violeta
    'educativos': '#16A085',                // Verde azulado
    'deportivos': '#E74C3C',                // Rojo
  },

  // Colores para condiciones - Usando colores estándar
  conditions: {
    excelente: '#27AE60',    // Verde - Excelente
    bueno: '#3498DB',        // Azul - Bueno
    regular: '#F1C40F',      // Amarillo - Regular
    malo: '#F39C12',         // Naranja - Malo
    pesimo: '#E74C3C',       // Rojo - Pésimo
  },

  // Color fijo para precios (no dinámico)
  price: {
    default: '#F39C12',      // Naranja fijo para todos los precios
  },

  // Gradientes del arcoíris - Versión estándar
  gradients: {
    rainbow: 'linear-gradient(45deg, #E74C3C, #F39C12, #F1C40F, #27AE60, #3498DB, #8E44AD, #9B59B6)',
    rainbowHorizontal: 'linear-gradient(90deg, #E74C3C, #F39C12, #F1C40F, #27AE60, #3498DB, #8E44AD, #9B59B6)',
    rainbowVertical: 'linear-gradient(180deg, #E74C3C, #F39C12, #F1C40F, #27AE60, #3498DB, #8E44AD, #9B59B6)',
    primary: 'linear-gradient(135deg, #3498DB, #27AE60)',      // Azul a verde
    secondary: 'linear-gradient(135deg, #F39C12, #E74C3C)',   // Naranja a rojo
    accent: 'linear-gradient(135deg, #8E44AD, #9B59B6)',      // Índigo a violeta
  },

  // Colores de fondo suaves
  backgrounds: {
    light: {
      red: '#FFF5F5',
      orange: '#FFF8F0',
      yellow: '#FFFEF0',
      green: '#F0FFF4',
      blue: '#F0F8FF',
      indigo: '#F8F5FF',
      violet: '#FDF2F8',
    },
    medium: {
      red: '#FFE5E5',
      orange: '#FFE8D6',
      yellow: '#FFF9C4',
      green: '#D4F5D4',
      blue: '#E1F0FF',
      indigo: '#F0E8FF',
      violet: '#FCE7F3',
    }
  }
};

// Función para obtener color por índice (para ciclos de colores)
export const getRainbowColorByIndex = (index: number): string => {
  const colors = Object.values(divertilandiaColors.rainbow);
  return colors[index % colors.length];
};

// Función para obtener color por nombre de categoría
export const getCategoryColor = (category: string): string => {
  if (!category) return divertilandiaColors.toyCategories['otros'];
  
  const categoryMap: { [key: string]: string } = {
    // Categorías específicas de tu base de datos
    'alberca de pelotas': '#F1C40F',        // Amarillo dorado
    'corralitos': '#27AE60',                // Verde esmeralda
    'inflables': '#E67E22',                 // Naranja oscuro
    'juguetes de construcción': '#3498DB',   // Azul cielo
    'montables': '#F39C12',                 // Naranja vibrante
    'tapetes': '#9B59B6',                   // Violeta suave
    'tuneles interactivos': '#E74C3C',      // Rojo coral
    
    // Categorías genéricas
    'pelotas': '#F1C40F',                   // Amarillo dorado
    'bloques': '#27AE60',                   // Verde esmeralda
    'muñecas': '#E74C3C',                   // Rojo coral
    'carros': '#3498DB',                    // Azul cielo
    'juegos': '#8E44AD',                    // Índigo púrpura
    'electrónicos': '#9B59B6',              // Violeta
    'educativos': '#16A085',                // Verde azulado
    'deportivos': '#E74C3C',                // Rojo
    'otros': '#95A5A6',                     // Gris neutro
  };
  
  return categoryMap[category.toLowerCase()] || '#95A5A6'; // Gris neutro por defecto
};

// Función para obtener color de condición
export const getConditionColor = (condition: string): string => {
  if (!condition) return divertilandiaColors.conditions.regular;
  
  const conditionMap: { [key: string]: string } = {
    // Español
    'excelente': '#27AE60',        // Verde - Excelente
    'bueno': '#3498DB',           // Azul - Bueno
    'regular': '#F1C40F',         // Amarillo - Regular
    'malo': '#F39C12',            // Naranja - Malo
    'pesimo': '#E74C3C',          // Rojo - Pésimo
    
    // Inglés (como viene del backend)
    'excellent': '#27AE60',       // Verde - Excelente
    'good': '#3498DB',            // Azul - Bueno
    'fair': '#F1C40F',            // Amarillo - Regular
    'poor': '#F39C12',            // Naranja - Malo
    'bad': '#E74C3C',             // Rojo - Pésimo
    
    // Otros posibles valores
    'muy bueno': '#27AE60',       // Verde
    'satisfactorio': '#3498DB',   // Azul
    'aceptable': '#F1C40F',       // Amarillo
    'defectuoso': '#F39C12',      // Naranja
    'inutilizable': '#E74C3C',    // Rojo
  };
  
  return conditionMap[condition.toLowerCase()] || '#F1C40F'; // Amarillo por defecto
};

// Función para obtener color de precio (ahora fijo)
export const getPriceColor = (price: number): string => {
  return divertilandiaColors.price.default; // Siempre el mismo color naranja
};

export default divertilandiaColors;
